module.exports = __webpack_public_path__ + "img/2.a1723cf0.png";